import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import EmployeeSessionBanner from '../components/EmployeeSessionBanner/EmployeeSessionBanner';
import type { AppShellProps } from './MobileShell';
import { useDeferredDesktopProFooter } from './useDeferredDesktopProFooter';
import './layoutShell.css';

/**
 * Chrome desktop : navbar complète, footer marketing, pas de bottom nav.
 */
export const DesktopShell: React.FC<AppShellProps> = ({ route, children }) => {
  const deferFooter = route.deferDesktopFooterUntilStable;
  const footerReady = useDeferredDesktopProFooter(deferFooter, route.pathname);
  const showFooter = !route.shouldHideFooter;
  const footerPending = deferFooter && !footerReady;

  return (
    <div
      className={`app-shell app-shell--desktop${route.showNavbar ? ' app-shell--with-navbar' : ''}`}
      data-app-shell="desktop"
    >
      {route.showNavbar && <Navbar />}
      {route.showEmployeeBanner && <EmployeeSessionBanner />}
      <main className="app-shell__content">{children}</main>
      {showFooter ? (
        <div
          className={
            footerPending
              ? 'app-shell__footer-slot app-shell__footer-slot--pending'
              : 'app-shell__footer-slot'
          }
          aria-hidden={footerPending ? true : undefined}
        >
          <Footer />
        </div>
      ) : null}
    </div>
  );
};
